import { mdiLock } from "@mdi/js";
import { type JSX, splitProps } from "solid-js";
import { cn } from "~/util/utils";
import { Group } from "../ui/group";
import { Icon } from "../ui/icon";
import { Stack } from "../ui/stack";
import { Text } from "../ui/text";

export function UnautharizedGraphic(props: JSX.HTMLAttributes<HTMLDivElement>) {
	const [local, other] = splitProps(props, ["class"]);

	return (
		<div
			class={cn("bg-gray-100 border p-3", local.class)}
			{...other}
		>
			<Group align="start">
				<Icon
					path={mdiLock}
					size="lg"
					color="yellow"
				/>
				<Stack>
					<Text
						class="font-bold"
						size="lg"
					>
						Inloggen vereist
					</Text>
					<Text>Je moet ingelogd zijn om dit artikel in te zien. Klik [hier] om in te loggen.</Text>
				</Stack>
			</Group>
		</div>
	);
}
